import { connect } from 'react-redux';

import { getCompositionDraft } from 'app/modules';
import { updateCompositionDraft } from 'app/modules/ui/actions';
import Composition from 'presentation/components/Composition.jsx';
import authOrCreateMessage from 'app/modules/messages/actions/authOrCreateMessage';
import { updateCustomerTypingState } from 'app/modules/session';

export const mapStateToProps = state => {
  return { prompt: 'Write a message', compositionDraft: getCompositionDraft(state) };
};

export const mapDispatchToProps = dispatch => {
  return {
    onSubmit: message => {
      dispatch(updateCompositionDraft(''));
      dispatch(authOrCreateMessage(message));
    },
    onChange: text => {
      dispatch(updateCompositionDraft(text));
    },
    onCustomerTypingStateUpdate: typingState => {
      dispatch(updateCustomerTypingState(typingState));
    },
  };
};

const CompositionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Composition);

export default CompositionContainer;
